/*
 * useEdgeWrite — a write to the selected edge's API, the way the settings
 * screens make them: the appliance's own words when it refuses, a sentence
 * when it does not answer, and a fresh read after either, so what the screen
 * shows is what the appliance holds, including after a write it saved but
 * could not put in place.
 */
import { useCallback, useState } from "react";
import { nodeApiUrlFor } from "../serverApi";
import { fetchWithTimeout } from "../utils/fetchWithTimeout";

export default function useEdgeWrite(nodeId, refresh) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const send = useCallback(async (method, path, body) => {
    setBusy(true);
    setError("");
    try {
      const res = await fetchWithTimeout(nodeApiUrlFor(nodeId)(path), {
        method,
        headers: { "Content-Type": "application/json" },
        body: body === undefined ? undefined : JSON.stringify(body),
      }).catch(() => null);
      if (!res) {
        setError("The appliance did not answer, so this change may not have been made.");
        return null;
      }
      if (!res.ok) {
        setError((await res.text().catch(() => "")).trim() || `The appliance refused this (HTTP ${res.status}).`);
        refresh();
        return null;
      }
      const out = await res.json().catch(() => null);
      refresh();
      return out;
    } finally {
      setBusy(false);
    }
  }, [nodeId, refresh]);

  return { busy, error, send };
}
